module.exports = {
  label: {
    date: 'Date',
    scriptId: 'Script ID',
    patientName: 'Name of Patient',
    gender: 'Gender',
    dob: 'DOB',
    bloodGroup: 'Blood Group',
    phoneNumber: 'Phone Number',
    address: 'Address',
    namePharmacist: 'Name of Pharmacist',
    email: 'Email',
    status: 'Status',
    paidBy: 'Paid by',
    totalPrice: 'Total Price of Script',
    adminCommissionPercentage: 'Admin’s Commission Percentage',
    adminCommissionAmount:'Admin’s Commission Amount',
    myAmount: 'My Amount',
    nodata:'----',
    copiedlink:'Link copied Successfully!!',
    errorIncopyLink:'Failed to copy link',
    idNumber: 'ID Number',
    icdCode: 'ICD10 code',
    patientMinor: 'Is Patient a Minor?',
    parentName: 'Name of Parent/Guardian',
    parentIDNumber: 'ID No. of Patient or Guardian',
//    medicineRequired: 'Medicine required',
    medicineRequired: 'Medicine requested by patient via request form',
    allergicTo:'Allergic to',
    patientImages:'Patient Images',
    nurseNote: 'Notes to patient',
    specialInstructions: 'Special instructions/other',
    error:'Something Went Wrong',
    prescription:'Prescription',
    medication_needed: 'Cannabis product needed - dose and frequency - If you are a new user please indicate it here / Notes',
    height: 'Height',
    weight: 'Weight',
    bmi: 'BMI',
    placeholder: {
      enterName: 'Enter Name',
    },
    buttons: {
      copyScript: 'Copy Script Link',
      copyEScript: 'Copy eScript Link',
      shareScript: 'Share Script Via Email',
      shareEScript: 'Share eScript Via Email'
    }
  }
}
